import { SCREEN_SIZE } from '../actionTypes';

export const setScreenSize = (size) => {
	return (dispatch) => {
		dispatch({ type: SCREEN_SIZE, size });
	};
};
